module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "GeofencingWhite_Icon.ca5f6fd2.png";